<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div>
    <el-card shadow="never" style="margin-top: 0px">
      <div style="margin-top: 10px">
        <el-form
          :inline="true"
          :model="queryParam"
          ref="queryForm"
          label-width="100px"
        >
          <el-form-item label="家长手机号:" prop="phoneNumber">
            <el-input
              v-model="queryParam.phoneNumber"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员名:" prop="memberName">
            <el-input
              v-model="queryParam.memberName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员小名:" prop="nikeName">
            <el-input
              v-model="queryParam.nikeName"
              placeholder="请输入小名"
            ></el-input>
          </el-form-item>
          <el-form-item label="上课日期:">
            <el-date-picker
              v-model="dateArr"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
              @change="handleChangeDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="current == 'VIP'" label="课程名:" prop="courseId">
            <el-select v-model="queryParam.courseId" placeholder="请选择">
              <el-option
                v-for="item in courseOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="warning"
              size="medium"
              class="operator-btn2"
              icon="el-icon-refresh"
              @click="handleResetSearch()"
              >重 置</el-button
            >
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-search"
              @click="onBtnSearch()"
              >查 询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="table-container" style="margin-top: 20px">
      <div class="d-flex jc-end ai-center manage-btn">
        <div class="spec-buton-box mr-1" v-if="current != 'VIP'">
          <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-setting"
            @click="handleSetting()"
            >参数设定</el-button
          >
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>

        <el-button
          v-if="current != 'VIP'"
          type="primary"
          size="medium"
          class="operator-btn"
          icon="el-icon-eleme"
          @click="handleComment()"
          >课评</el-button
        >
        <div class="spec-buton-box mr-1">
          <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-eleme"
            @click="handleMultimedia()"
            >多媒体</el-button
          >
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>

        <el-button
          v-if="current == 'A'"
          type="primary"
          size="medium"
          class="operator-btn"
          icon="el-icon-upload"
          @click="handleMaintain()"
          >维护泳圈信息</el-button
        >
      </div>
      <!-- @selection-change="handleSelectionChange" -->
      <el-table
        key="outside"
        ref="multipleTable"
        style="width: 100%"
        :data="tableData"
        max-height="540"
        v-loading="listLoading"
        @select="handleSelectionChange"
        border
        highlight-current-row
        :header-cell-style="{
          'text-align': 'center',
          background: '#edf3fe',
          color: '#0d6fb8',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column type="selection" width="70"> </el-table-column>
        <el-table-column
          prop="classDate"
          label="上课日期"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="classTime"
          label="上课时间"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="courseName"
          label="课程名称"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="signInTime"
          min-width="120"
          :label="current == 'VIP' ? '会员签到时间' : '签到时间'"
        ></el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="memberName"
          label="会员名"
          min-width="100"
        ></el-table-column>
        <el-table-column
          v-if="current == 'VIP'"
          prop="ageInMonths"
          label="月龄"
        />
        <el-table-column
          v-if="current == 'VIP'"
          prop="childrenLevel"
          label="级别"
        />
        <el-table-column
          prop="nickname"
          label="小名"
          min-width="100"
          v-if="current != 'VIP'"
        ></el-table-column>
        <el-table-column
          min-width="100"
          prop="serviceTeacher"
          :label="current == 'VIP' ? '上课老师' : '服务老师'"
        ></el-table-column>
        <el-table-column
          v-if="current == 'A'"
          prop="swimmingRings"
          label="泳圈"
          width="120"
        ></el-table-column>
        <el-table-column label="评价" width="340" v-if="current != 'VIP'">
          <template slot-scope="scope">
            <el-table
              v-if="scope.row.evaluate.data && scope.row.evaluate.data.length"
              key="outside-in"
              border
              :data="scope.row.evaluate.data"
              :header-cell-style="{
                'text-align': 'center',
                background: '#edf3fe',
                color: '#0d6fb8',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column
                v-for="(val, index) in scope.row.evaluate.column"
                :key="index"
                :prop="val.field"
                :label="val.name"
              ></el-table-column>
            </el-table>
            <div v-else>暂无评价</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="interactiveContent"
          label="互动内容"
          min-width="100"
          show-overflow-tooltip=""
          v-if="current == 'VIP'"
        ></el-table-column>
        <el-table-column
          prop="memberSatisfaction"
          label="会员满意度"
          min-width="100"
        ></el-table-column>
        <el-table-column prop="courseState" label="课程状态"></el-table-column>
        <el-table-column prop="remark" label="文字"></el-table-column>
        <el-table-column label="语音" v-if="current != 'VIP'">
          <template slot-scope="{ row }">
            <i
              v-if="row.multimedia.audio"
              style="font-size: 22px; color: #0e6fb8"
              class="el-icon-microphone"
              @click="clickAudio(row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.multimedia.image && row.multimedia.image.length"
              style="width: 40px; height: 40px"
              :src="row.multimedia.image[0]"
              :preview-src-list="row.multimedia.image"
            >
            </el-image>
            <div v-else>暂无数据</div>
          </template>
        </el-table-column>
        <el-table-column label="视频">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.multimedia.video && row.multimedia.video.length"
              type="text"
              @click="handleLook(row.multimedia.video)"
              >点击查看</el-button
            >
            <div v-else>暂无数据</div>
          </template>
        </el-table-column>
        <el-table-column label="更多" v-if="current == 'VIP'">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleUpdate(row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage"
      >
      </el-pagination>
    </div>
    <!-- 参数设定弹窗 -->
    <el-dialog
      :visible.sync="visibleSetting"
      title="参数设定"
      width="40%"
      center
    >
      <div class="overflow-hidden">
        <paramsSetting
          ref="setting"
          :currentType="current"
          :options="courseOptions"
        ></paramsSetting>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="buttonLoading"
          type="primary"
          @click="handleSettingSave"
          >保 存</el-button
        >
        <el-button @click="visibleSetting = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 课评弹窗 -->
    <el-dialog :visible.sync="visibleComment" title="课评" width="30%" center>
      <div class="overflow-hidden">
        <comment
          :currentType="current"
          ref="commentRef"
          :courseRocordId="checkedId"
          :defaultConfig="defaultConfig"
          :swimInfoTable="swimInfoTable"
        ></comment>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="buttonLoading"
          type="primary"
          @click="handleMaintainSubmit"
          >提 交</el-button
        >
        <el-button @click="visibleComment = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 多媒体弹窗 -->
    <el-dialog
      :visible.sync="visibleMultimedia"
      title="多媒体上传"
      width="30%"
      center
    >
      <div class="overflow-hidden">
        <multimediaVue
          ref="multimediaRef"
          :courseRocordId="checkedId"
          :defaultConfig="defaultConfig"
          :currentRow="checkedData"
        ></multimediaVue>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="buttonLoading"
          type="primary"
          @click="handlMultimeSubmit"
          >提 交</el-button
        >
        <el-button @click="visibleMultimedia = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 维护泳圈信息弹窗 -->
    <el-dialog
      :visible.sync="visibleMaintain"
      title="维护泳圈信息"
      width="30%"
      center
    >
      <div class="overflow-hidden">
        <el-button
          style="margin-bottom: 10px"
          type="primary"
          size="medium"
          class="operator-btn"
          @click="handleAddInfomation()"
          >添加泳圈信息</el-button
        >
        <el-table
          :data="swimInfoTable"
          border
          key="inside"
          :header-cell-style="{
            'text-align': 'center',
            background: '#edf3fe',
            color: '#0d6fb8',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="name" label="泳圈"> </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCloseSave">保 存</el-button>
        <el-button @click="visibleMaintain = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加泳圈信息弹窗 -->
    <el-dialog
      :visible.sync="visibleInfomation"
      title="添加泳圈信息"
      width="20%"
      center
    >
      <el-form
        ref="infomationForm"
        :rules="infoRules"
        :model="infomationForm"
        label-width="80px"
      >
        <el-form-item label="泳圈" prop="name">
          <el-input
            v-model="infomationForm.name"
            placeholder="请输入泳圈"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleInfomation = false">取 消</el-button>
        <el-button type="primary" @click="handleSureInfo('infomationForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 视频弹窗 -->
    <el-dialog :visible.sync="videoDialog" width="60%" center>
      <div style="height: 600px">
        <videoDialogVue :list="videoList"></videoDialogVue>
      </div>
    </el-dialog>

    <template v-if="audioDialog">
      <el-dialog
        title="音频文件"
        width="500px"
        :visible.sync="audioDialog"
        center
      >
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
    <!-- 课评口令 -->
    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
  </div>
</template>

<script>
import globaldata from "@/utils/globaldata";
import { selectWorkerPosition, updateposition } from "@/api/storeFront";

import commonUtils from "@/utils/commonUtils";
import messageUtils from "@/utils/messageUtils";
import { qlSwCircle, updateSwCle } from "@/api/StoreSetting";
import paramsSetting from "./params-setting.vue";
import comment from "./comment.vue";
import multimediaVue from "../../components/multimedia.vue";
import videoDialogVue from "@/components/video/video-dialog.vue";
import audioDialog from "@/components/audioDialog";
import WorkerWord from "@/components/WorkerWord/WorkerWord";

import {
  finishList,
  courseList,
  setCourseConfig,
  getConfigData,
  updateCourseEval,
  updateCourseMedia,
} from "@/api/AfterClassService";
export default {
  components: {
    paramsSetting,
    comment,
    multimediaVue,
    videoDialogVue,
    audioDialog,
    WorkerWord,
  },
  props: {
    current: {
      type: String,
      default: "A",
    },
  },
  data() {
    return {
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
      queryParam: {
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        phoneNumber: undefined, //手机号码
        memberName: undefined, //会员名
        nikeName: undefined, //会员小名
        beginDate: undefined, //开始时间
        endDate: undefined, //结束时间
        courseId: undefined, //课程名id
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      dateArr: [],
      courseOptions: [], //课程列表数据
      defaultConfig: {},
      listLoading: false,
      buttonLoading: false, //按钮loading
      audioDialog: false,
      videoList: [], //视频列表
      tableData: [
        // {
        //   evaluate: {
        //     column: [
        //       {
        //         title: "身高",
        //         attribute: "height",
        //       },
        //     ],
        //     data: [
        //       {
        //         height: 1.72,
        //       },
        //     ],
        //   },
        //   picUrl:
        //     "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        //   videoUrl: "https://www.runoob.com/try/demo_source/mov_bbb.mp4",
        // },
        // {
        //   evaluate: {
        //     column: [
        //       {
        //         title: "身高",
        //         attribute: "height",
        //       },
        //       {
        //         title: "体重",
        //         attribute: "weight",
        //       },
        //       {
        //         title: "游泳姿态",
        //         attribute: "swimmingPosture",
        //       },
        //     ],
        //     data: [
        //       {
        //         height: 1.6,
        //         weight: 55,
        //         swimmingPosture: "欠佳",
        //       },
        //     ],
        //   },
        // },
      ],
      checkedId: null, //选中的id
      checkedData: {}, //选中的项
      selectedList: [], //选中的项
      videoDialog: false, //视频弹窗
      visibleSetting: false, //参数设定弹窗是否显示
      settingForm: {},
      visibleComment: false, //课评弹窗是否显示
      visibleMultimedia: false, //多媒体弹窗
      visibleMaintain: false, //维护泳圈信息弹窗
      visibleInfomation: false, //添加泳圈弹窗
      infomationForm: {},
      swimInfoTable: [], //泳圈数据列表
      infoRules: {
        name: [{ required: true, message: "请输入泳圈名", trigger: "blur" }],
      },
      isVip: globaldata.getAdminStore().isVip,

    };
  },
  mounted() {
    this.getCourseList();
    this.getList();
    this.flechList();
  },
  methods: {
    clickAudio(val) {
      console.log(val, "val");
      this.audioDialog = true;

      this.$nextTick(() => {
        this.$refs.audioDialogRef.audio = val.multimedia.audio;
      });
      console.log(val, this.$refs.audioDialogRef, "refs.audioDialogRef=======");
    },
    // 查询课程列表
    getCourseList() {
      let params = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        pageNum: 1,
        pageSize: 10,
        storeTemplateId:
          this.current == "A" ? 2 : this.current == "B" ? 1 : undefined,
      };
      courseList(params).then((response) => {
        console.log("课程", response);
        this.courseOptions = response.data.list;
      });
    },
    // 课程服务列表
    getList() {
      this.listLoading = true;
      let params = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        lessonTemplateId:
          this.current == "A" ? 2 : this.current == "B" ? 1 : undefined,
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
        mediaIsNotNull: this.current == "VIP" ? true : false,
        phoneNumber: this.queryParam.phoneNumber, //手机号码
        memberName: this.queryParam.memberName, //会员名
        nikeName: this.queryParam.nikeName, //会员小名
        beginDate: this.queryParam.beginDate, //开始时间
        endDate: this.queryParam.endDate, //结束时间
        courseId: this.queryParam.courseId,
      };
      finishList(params).then((response) => {
        this.listLoading = false;
        this.queryParam.totalPage = response.data.total;
        this.tableData = response.data.list;
      });
    },

    flechList() {
      this.listLoading = true;
      let param = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      qlSwCircle(param).then((response) => {
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.swimInfoTable = date;
      });
    },
    // 重置按钮点击事件
    handleResetSearch() {
      this.checkedId = null;
      this.dateArr = [];
      this.$set(this.queryParam, "beginDate", undefined);
      this.$set(this.queryParam, "endDate", undefined);
      this.$refs.queryForm.resetFields();
      this.onBtnSearch();
    },
    // 查询按钮点击事件
    onBtnSearch() {
      this.queryParam.pageNum = 1;
      this.getList();
    },
    handleChangeDate(e) {
      if (e.length) {
        this.$set(this.queryParam, "beginDate", e[0]);
        this.$set(this.queryParam, "endDate", e[1]);
      }
    },
    // 视频查看按钮
    handleLook(url) {
      this.videoList = url;
      this.videoDialog = true;
    },
    // 修改按钮事件
    handleUpdate(row) {
      console.log("行", row);
      this.checkedData = row;
      this.checkedId = row.id;
      this.getConfigItem(row.storeLessonsId, "multimedia");
    },
    // 参数设定按钮弹窗
    handleSetting() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.visibleSetting = true;
    },
    // 参数设定弹窗保存按钮事件
    handleSettingSave() {
      if (!this.$refs.setting.courseId)
        return this.$message.warning("请选择课程名称!");
      let params = {
        ...this.$refs.setting.defaultForm,
        id: this.$refs.setting.courseId,
      };
      console.log(params, "params");
      this.buttonLoading = true;
      setCourseConfig(params)
        .then((response) => {
          console.log("设置", response);
          if (response.code == 20000) {
            this.$message.success("提交成功");
            this.visibleSetting = false;
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },

    // 课评按钮事件
    handleComment() {
      if (!this.checkedId) return this.$message.warning("请先选择一条课评!");
      this.getConfigItem(this.checkedData.storeLessonsId, "comment");
    },
    // 课评弹窗提交事件
    handleMaintainSubmit() {
      let comment = {};
      this.$refs.commentRef.courseForm.dimensions.map((item) => {
        comment[item.field] = item.value;
      });
      let params = {
        id: this.checkedId,
        comment: JSON.stringify(comment),
        swimmingRings: this.$refs.commentRef.courseForm.swimmingRings,
        gold: this.$refs.commentRef.courseForm.gold
          ? Number(this.$refs.commentRef.courseForm.gold)
          : null,
        remark: this.$refs.commentRef.courseForm.remark,
      };
      this.doRefreshWord(true, 1, params);
      return;
      this.buttonLoading = true;
      updateCourseEval(params)
        .then((response) => {
          if (response.code == 20000) {
            this.$message.success("提交成功");
            this.visibleComment = false;
            this.getList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    // 多媒体按钮点击事件
    handleMultimedia() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (!this.checkedId) return this.$message.warning("请先选择一条课评!");
      this.getConfigItem(this.checkedData.storeLessonsId, "multimedia");

      // this.visibleMultimedia = true;
      // this.$nextTick(() => {
      //   this.$refs.multimediaRef.resetForm();

      //   this.$refs.multimediaRef.getFetch();
      // });
    },
    // 多媒体弹窗提交按钮事件
    handlMultimeSubmit() {
      let self = this;
      let params = {
        userId: self.checkedData.userId,
        identityId: self.checkedId,
        video: self.$refs.multimediaRef.multimediaForm.video,
        image: self.$refs.multimediaRef.multimediaForm.image,
        audio: self.$refs.multimediaRef.multimediaForm.audio,
        remark: self.$refs.multimediaRef.multimediaForm.remark,
        // audio:self.$refs.multimediaRef.$refs.soundRecord.audio
      };
      this.doRefreshWord(true, 2, params);
      return;
      self.buttonLoading = true;
      updateCourseMedia(params)
        .then((response) => {
          if (response.code == 20000) {
            self.$message.success("提交成功");
            self.visibleMultimedia = false;
            self.checkedId = null;
            self.$nextTick(() => {
              self.$refs.multimediaRef.resetForm();
            });
            self.getList();
          }
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      } else if (wordType == 2) {
        this.doMultimeCourse(tData);
      }
    },
    doBuyExpCard(param) {
      updateCourseEval(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          this.$message.success("提交成功");
          this.visibleComment = false;
          this.wordData = response.data;
          this.checkedId = null;
          this.getList();
        } else {
          messageUtils.errorMsg(this, response.message);
          this.initData();
        }
      });
    },
    doMultimeCourse(param) {
      let self = this;
      updateCourseMedia(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          self.$message.success("提交成功");
          self.visibleMultimedia = false;
          self.checkedId = null;
          self.$nextTick(() => {
            self.$refs.multimediaRef.resetForm();
          });
          self.getList();
        }
      });
    },
    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    // 维护泳圈信息事件
    handleMaintain() {
      // if (!this.checkedId) return this.$message.warning("请先选择一条课评!");
      this.visibleMaintain = true;
    },
    // 添加泳圈信息
    handleAddInfomation() {
      this.visibleInfomation = true;
    },
    // 维护泳圈弹窗保存事件
    handleCloseSave() {
      this.visibleMaintain = false;
    },
    // 添加泳圈信息弹窗的确定事件
    handleSureInfo(infomationForm) {
      this.$refs[infomationForm].validate((valid) => {
        if (valid) {
          console.log("通过校验");
          // //不能添加重复的
          for (let i = 0; i < this.swimInfoTable.length; ++i) {
            if (this.infomationForm.name == this.swimInfoTable[i].name) {
              messageUtils.errorMsg(this, "不能添加重复泳圈");
              return;
            }
          }

          let data = {
            name: this.infomationForm.name,
          };
          let t = this.swimInfoTable;
          t.push(data);
          this.doUpdateSw();
        } else {
          console.log("校验未通过");
          return false;
        }
      });
    },
    doUpdateSw() {
      let param = {
        // storeFrontId: 2201,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        swimCircleDetails: [],
      };
      for (let i = 0; i < this.swimInfoTable.length; ++i) {
        let data = {
          name: this.swimInfoTable[i].name,
          statu: 0,
        };
        param.swimCircleDetails.push(data);
      }
      updateSwCle(param).then((response) => {
        this.visibleInfomation = false;
        this.infomationForm.name = undefined;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        if (date == true) {
          messageUtils.successMsg(this, response.message);
          this.flechList();
        }
      });
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.getList();
    },
    handleSelectionChange(selection, val) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
      this.checkedData = selection[0];
      console.log(this.checkedData, "行");
      let checkedIds = selection.map((item) => item.id);
      this.checkedId = checkedIds[0];
      // this.getConfigItem(selection[0].storeLessonsId);
    },
    // 查询课程配置
    getConfigItem(courseId, currentPlace) {
      getConfigData({ id: courseId }).then((response) => {
        console.log("配置", response.data);
        this.defaultConfig = response.data;
        if (currentPlace == "comment") {
          this.visibleComment = true;
          this.$nextTick(() => {
            this.$refs.commentRef.getFetch();
          });
        } else if (currentPlace == "multimedia") {
          this.$nextTick(() => {
            this.$refs.multimediaRef.resetForm();
            this.$refs.multimediaRef.getFetch();
          });
          this.visibleMultimedia = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  text-align: left !important;
}
.table-container {
  border: 0px;
}
.manage-btn {
  background-color: #fff;
  padding: 20px !important;
  text-align: right;
  box-sizing: border-box;
}
.overflow-hidden {
  height: 540px;
  overflow-x: hidden;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>



// WEBPACK FOOTER //
// src/views/service/course-evaluation-A/components/course-evaluate-common.vue